<template>
  <b-container fluid class="p-4">
    <h3 class="mb-4">پروفایل</h3>
    <profile-component
      :submit="updateProfile"
      :form="profile"
      :changeRole="false"
    />
  </b-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ProfileComponent from "../../../components/dashboard/Profile.vue";

export default {
  name: "profile",
  components: { ProfileComponent },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile",
    }),
  },
  methods: {
    updateProfile() {
      console.log(this.profile, "update");
      this.$store.dispatch("User/editProfile", this.profile);
    },
  },
  mounted() {},
};
</script>
<style scoped>
h3 {
  color: #bf61ea;
}
</style>
